import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const host = process.env.REACT_APP_TRANSLATIONS_HOST;

i18n
  .use(Backend)            // loads translations via HTTP
  .use(initReactI18next)   // passes i18n down to React hooks
  .init({
    fallbackLng: "en",     // fallback locale
    lng:        "en",      // initial language
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${host}/i18n/{{lng}}.json`,
    },
  });

export default i18n;